import { render, staticRenderFns } from "./SetController.vue?vue&type=template&id=5095f73a&scoped=true"
import script from "./SetController.vue?vue&type=script&lang=js"
export * from "./SetController.vue?vue&type=script&lang=js"
import style0 from "./SetController.vue?vue&type=style&index=0&id=5095f73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095f73a",
  null
  
)

export default component.exports